import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 20 }) => (
  <svg
    width={dimension}
    height={dimension}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2Z" fill="currentColor" />
    <path d="M11 10H13V14H11V10Z" fill="currentColor" />
    <path d="M11 16H13V18H11V16Z" fill="currentColor" />
  </svg>
);

export default Icon;
